import { Component, OnInit } from '@angular/core';
import {
  NavigationEnd,
  NavigationStart,
  RouteConfigLoadEnd,
  RouteConfigLoadStart,
  Router,
} from '@angular/router';
import { NavigationService } from '@app/shared/common/navigation/navigation.service';
import { SettingsService } from '@app/shared/common/services/Authentication/settings.service';
import { WebSocketConfigService } from '@app/shared/common/services/Authentication/web-socket-config.service';
import { ConfigurationsService } from '@app/shared/common/services/Configuration/configurations.service';
import { CommonMethodsService } from '@app/shared/common/services/common-methods.service';
import { LoaderService } from '@app/shared/common/services/loader.service';
import { SignalRConnectionService } from '@app/shared/common/services/signal-r-connection.service';
import { getCurrentUser, setCurrentUser } from '@app/shared/common/utils/app-utils';

@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss'],
  standalone:false
})
export class PageComponent implements OnInit {
  public showHeaderFooter: boolean = false;
  public showLoader: boolean = false;
  public isPermissionsLoaded: boolean = false;
  public isUserLoggedIn: boolean = false;
  public user={name:'',email:''}

  constructor(
    public loaderService: LoaderService,
    private settinService: SettingsService,
    private router: Router,
    private webSocketService: WebSocketConfigService,
    private SignalRConnectionService: SignalRConnectionService,
    private configService: ConfigurationsService,
    private commonService: CommonMethodsService,
    private navigationService:NavigationService,
  ) {
    // To hide header and footer from login page
    this.router.events.subscribe((event: any) => {
      if (event instanceof RouteConfigLoadStart) {
        this.showLoader = true;
      } else if (event instanceof RouteConfigLoadEnd) {
        this.showLoader = false;
      }
      if (event instanceof NavigationStart) {
        //for future reference
      }
      if (event instanceof NavigationEnd) {
        //event url segnifies that its after login
        if(!(event.url=='/' || event.url.includes('/login') || event.url.includes('/privacy-notice'))){
          this.showHeaderFooter=true
        }
        if(event.url.includes('access_token') && this.settinService.isUserLoggedin()){
          this.isUserLoggedIn=true
          this.loadUserDetails()
          this.onEachLoad()
        }
        // closing any tooltip remained open in previous page
        this.closeAllTooltips()
      }
    });
  }
  ngOnInit(): void {
    this.loaderService.isLoading.subscribe((data: any) => {
      this.showLoader = data;
    });
    this.onEachLoad(true)
  }
  public loadUserDetails(){
    this.commonService.getUserDetails(true)?.subscribe(
      (data)=>{
        this.commonService.setIsUserDetailsLoaded(true)
        this.commonService.setPrivacyAccepted(data.privacyAccepted)
        this.user=data
        setCurrentUser(data)
        if(data.privacyAccepted){
          this.navigationService.navigateTo(this.navigationService.getHomePageUrl)
        }
        else{
          this.navigationService.navigateTo(this.navigationService.getPrivacyNoticeUrl)
        }
      }
    );
  }
  public closeAllTooltips() {
    const closeArray=document.querySelectorAll(
      '#custom-teams-operation-tooltip  .motif-tooltip-close-button'
    );
    closeArray.forEach((ele: any) => ele.click())

  }

  public onEachLoad(loadUserDatail:boolean=false){
    if(loadUserDatail){
      // uses this for manual reload
      this.user=getCurrentUser()
      this.isUserLoggedIn=true
      this.commonService.setPrivacyAccepted(true)
    }
    if (this.settinService.isUserLoggedin() && !this.isPermissionsLoaded) {
      this.isPermissionsLoaded = true;
      this.settinService.getPermissionsByModule();
      // this.WebsocketConnect();
      this.configService.getRegionConfig()
      // this.Signal
      // RConnectionService.getAllNotifications();
    }
  }

  WebsocketConnect() {
    let stompClient = this.webSocketService.connect();
    console.log(stompClient);
    console.log(stompClient?.connected);
    // stompClient.subscribe((res: any) => {
    //   console.log(res);
    // });
    stompClient.connect({}, (frame: any) => {
      console.log(frame);
      console.log(stompClient?.connected);
      // Subscribe to notification topic
      stompClient.subscribe('api/topic/signoff', (notifications: any) => {
        // Update notifications attribute with the recent messsage sent from the server
        console.log(notifications);
      });
      stompClient.subscribe('api/topic/signOff', (notifications: any) => {
        // Update notifications attribute with the recent messsage sent from the server
        console.log(notifications);
      });
      stompClient.subscribe('api/topic/topic/signOff', (notifications: any) => {
        // Update notifications attribute with the recent messsage sent from the server
        console.log(notifications);
      });
    });
  }
}
